export default __webpack_public_path__ + "static/media/ic-twitter.8381ccc0.svg";